/** Returns a function which takes a Datum and index as input, and returns a formatted label object. */
export default function labelTransformFactory(_ref) {
  let {
    scale,
    labelFormat
  } = _ref;
  return (d, i) => ({
    datum: d,
    index: i,
    text: `${labelFormat(d, i)}`,
    value: scale(d)
  });
}